export default __webpack_public_path__ + "static/media/transnistria.577fd7ad.svg";